import {ApiService} from "./api.service";

export class AnalyticEventService extends ApiService{
  constructor(organizationId) {
    super();
    this.endpoint = `/organizations/${organizationId}/analytic_events`;
  }
}
